import {Paper, Table, TableContainer} from "@mui/material";
import {FC, ReactNode} from "react";
import {SxType} from "@baseTypes/sx/sxTypes";

interface IProps{
    children:ReactNode,
    prevContainerChildren?:ReactNode,
    sx?:SxType,
    sxContainer?:SxType,
    size?:'small' | 'medium',
    stickyHeader?:boolean,
    className?:string,
}
const TableCustomUi:FC<IProps> = ({
                                      children,
                                      prevContainerChildren,
                                      sxContainer={},
                                      sx,
                                      size='small',
                                      stickyHeader,
                                      className,
}) => {
    return (
        <TableContainer
            className={className}
            sx={{
                height:'100%',
                maxHeight: stickyHeader ? "calc(90vh - 64px)" : 'inherit',
                ...sxContainer,
            }}
            component={Paper}
        >
            {prevContainerChildren && prevContainerChildren}
            <Table
                stickyHeader={stickyHeader}
                size={size}
                sx={sx}
            >
                {children}
            </Table>

        </TableContainer>
    );
};

export default TableCustomUi;